import keyMirror from "keymirror";

const features = {
  ALERTS_V3: true,
  APP_PARAMETERS_V3: true,
  CONTENT_GROUPS: true,
  DEVICE_BULK_EDIT: true,
  DEVICE_EVENTS: true,
  DEVICE_INCIDENTS: true,
  ENABLE_AUDIO_FLAG: true,
  SCHEDULED_DEPLOYMENTS: true,
  STRATEGIES_V2_WEBPAGES: true,
};

const featureConsts = keyMirror(features);

class Features {
  static get constants() {
    return featureConsts;
  }

  static isEnabled(feature) {
    return features[feature];
  }
}

export { Features, features };
